<div id="academy-courses" class="page-layout simple">

    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text" fxLayout="row" fxLayoutAlign="start center">

            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          {{'WIZARD.LANDING_REQUERIMIENTOSV3.TITULO' | translate}}
            </h1>
        </div>

    </div>
    <div class="content p-24">
<div fxLayout="column" fxLayoutAlign="center">
    <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
        <!-- <ng-container *ngIf="cargando">
            <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div fxLayout="column" fxLayoutAlign="space-between center">
                    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                    <h2>{{'LANDINFOCUS.WIZARD.CARGANDOF' | translate}}</h2>
                </div>
            </div>
        </ng-container> -->

<ng-container *ngIf="mostrarEncuestas">
    <div class="" fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="100">
        <ng-container *ngIf="mostrarEncuestas.data.length==0">
            <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2>{{'LANDINFOCUS.ENCUESTAS.NO-ENCU' | translate}}</h2>
                    <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="mostrarEncuestas.data.length>0">

            <div class="" fxLayout="row wrap">
                <ng-container *ngFor="let encuestas of mostrarEncuestas.data">
                    <div class="course" fxFlex="100" fxFlex.gt-sm="33">
                        <div class="cursoCard" fxFlex="100">
                            <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                                <div class="header primary " fxLayout="row" fxLayoutAlign="center center">
                                    <!-- <div class="category" fxFlex>{{'LANDINFOCUS.ENCUESTAS.TITULO' | translate}}</div> -->
                                </div>

                                <div class="content  p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                    <div class="h1 p-20 m-20">{{encuestas.nombre}} </div>
                                </div>

                                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                    <button mat-button class="accent rndBt" fxFlex="100" (click)="navigateTo('/requirements-detail',encuestas._id);">{{'WIZARD.LANDING.ENTRAR' | translate}}</button>

                                </div>



                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>
        </ng-container>
    </div>

</ng-container>
</div>
</div>
